import { useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useEffectOnce, useKeyPressEvent, useObservable } from 'react-use';
import { rage, useMouseButton } from '~/rage';
import { KeyPressStates, MouseButton } from '~/shared';
import { Background } from '../../components/Background';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setInterfaceHidden } from '../../redux/slices/menuPanelsSlice';
import { resetStore } from '../../redux/wrappers';
import { Header } from '../Header';
import { VehicleSelection } from '../VehicleSelection';

const VehicleShop = () => {
	const selectedVehicle = useLayoutSelector(
		(state) => state.vehicleSelection.selectedVehicle,
	);
	const interfaceHidden = useLayoutSelector(
		(state) => state.menuPanels.interfaceHidden,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const dispatch = useLayoutDispatch();

	useEffectOnce(() => {
		// Перетаскивание
		const handleDragging = (e: any) => {
			e.preventDefault();
		};
		document.addEventListener('dragstart', handleDragging);
		return () => document.removeEventListener('dragstart', handleDragging);
	});

	// Запрет фокусировки на Tab
	useKeyPressEvent('Tab', (event) => event.preventDefault());

	const handleMouseButton = useCallback(
		(state: KeyPressStates) => {
			if (!selectedVehicle && state === KeyPressStates.Pressed && !modalState) {
				dispatch(setInterfaceHidden(true));
			} else if (state === KeyPressStates.Unpressed) {
				dispatch(setInterfaceHidden(false));
			}
		},
		[selectedVehicle, modalState],
	);

	useMouseButton(MouseButton.Right, handleMouseButton, {
		state: KeyPressStates.Both,
	});

	useEffectOnce(() => {
		return () => {
			dispatch(resetStore());
		};
	});

	return (
		<div onContextMenu={(e) => e.preventDefault()}>
			<Background />
			<VehicleSelection />
			<CSSTransition
				in={interfaceHidden}
				classNames={'interface'}
				timeout={500}
			>
				<Header />
			</CSSTransition>
		</div>
	);
};

export { VehicleShop };
